import { render, staticRenderFns } from "./access-denied.vue?vue&type=template&id=986de8c6&scoped=true&"
var script = {}
import style0 from "./access-denied.vue?vue&type=style&index=0&id=986de8c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986de8c6",
  null
  
)

export default component.exports